import { render, staticRenderFns } from "./ModalNotificacao.vue?vue&type=template&id=380c7b3e&scoped=true"
import script from "./ModalNotificacao.vue?vue&type=script&lang=js"
export * from "./ModalNotificacao.vue?vue&type=script&lang=js"
import style0 from "./ModalNotificacao.vue?vue&type=style&index=0&id=380c7b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380c7b3e",
  null
  
)

export default component.exports